import {
  Card,
  CardActionArea,
  CardContent,
  CardHeader,
  CardMedia,
  Typography,
} from '@cambridgeassessment/cambridge-ui';
import React, { memo, useCallback } from 'react';
import { hot } from 'react-hot-loader/root';
import { CambridgeProduct, GACategory } from 'src/types';
import { sendGAEvent } from 'src/utils/googleAnalytics';
import useAuth from '../../hooks/useAuth';
import { useStyles } from './styles';

const Product: React.FC<CambridgeProduct> = ({
  title,
  description,
  imageUrl,
  url,
}) => {
  const { user } = useAuth();

  const classes = useStyles();

  const handleClick = useCallback(() => {
    sendGAEvent(
      GACategory.products,
      `${user.roles} clicked on product tile ${title}`
    );
    window.location.assign(url);
  }, [user.roles, title, GACategory.products, url]);

  return (
    <Card>
      <CardActionArea onClick={handleClick}>
        <CardMedia image={imageUrl} />
        <CardContent>
          <CardHeader title={title} />
          <Typography
            className={classes.paragraph}
            variant="body1"
            color="textSecondary"
            dangerouslySetInnerHTML={{ __html: description }}
          ></Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default hot(memo(Product));
